import StatBox from './StatBox';

export default StatBox;

export type { IStatBoxProps } from './StatBox';
